export default __webpack_public_path__ + "static/media/laptop1.bb105923.svg";